<template>
  <div class="homeView">
    <!-- value.typeModule2?value.typeModule2:value.typeModule1 -->
    <div
      v-for="(value,index) in datas "
      :key="index"
      :class="getClass(value.typeModule1,value.typeModule2)"
    >
      <!-- 轮播图 -->
      <div class="first-carousel" v-if="value.typeModule2 === 2&& index === 0">
        <el-carousel trigger="click" height="400px">
          <el-carousel-item v-for="(v,i) in value.data" :key="i">
            <a v-if="v.linkSrc" :href="v.linkSrc" target="__blank" class="link">
              <img :src="v.imgSrc" alt />
            </a>
            <a v-else href="javascript:;" class="link noLink">
              <img :src="v.imgSrc" alt />
            </a>
          </el-carousel-item>
        </el-carousel>
      </div>
      <el-carousel v-if="value.typeModule2 === 2 && index !== 0" trigger="click" height="400px">
        <el-carousel-item v-for="(v,i) in value.data" :key="i">
          <a v-if="v.linkSrc" :href="v.linkSrc" target="__blank" class="link">
            <img :src="v.imgSrc" alt />
          </a>
          <a v-else href="javascript:;" class="link noLink">
            <img :src="v.imgSrc" alt />
          </a>
        </el-carousel-item>
      </el-carousel>
      <!-- 海报图 -->
      <div v-if="value.typeModule2 === 1" class="poster-container">
        <a v-if="value.data[0].linkSrc" target="__blank" :href="value.data[0].linkSrc" class="link">
          <img :src="value.data[0].imgSrc" alt />
        </a>
        <a v-else href="javascrit:;" class="link noLink">
          <img :src="value.data[0].imgSrc" alt />
        </a>
      </div>
      <!-- 广告图 -->
      <div v-if="value.typeModule2 === 3" class="banner-container">
        <a v-if="value.data[0].linkSrc" target="__blank" :href="value.data[0].linkSrc" class="link">
          <img :src="value.data[0].imgSrc" alt />
        </a>
        <a v-else href="javascrit:;" class="link noLink">
          <img :src="value.data[0].imgSrc" alt />
        </a>
      </div>
      <!-- 5块商品图 -->
      <div v-if="value.typeModule2 === 'table'" class="table-container">
        <div v-for="(v, i) in value.data" :key="i">
          <img class="img" :src="v.commodityImg" alt @click="toProduct(v.commodityId)" />
          <p
            class="title"
            @click="toProduct(v.commodityId)"
            :title="v.commodityName"
          >{{ v.commodityName }}</p>
          <p class="price" v-if="displayPrice">￥{{ v.retailPrice }}</p>
          <p class="price" v-else>登录享优惠</p>
        </div>
      </div>
      <!-- 3大块展示 -->
      <div v-if="value.typeModule1 === 2" class="smallModule-container">
        <div v-for="(v, i) in value.data" :key="i">
          <!-- 海报图 -->
          <div v-if="v.moduleType === 1" :class="v.data.length > 1?'poster-two':'poster-one'">
            <div v-for="(val, ind) in v.data" :key="ind" class="content">
              <a v-if="val.linkSrc" target="__blank" :href="val.linkSrc" class="link">
                <!-- <img :src="val.imgSrc" alt /> -->
                <el-image :src="val.imgSrc" fit="contain"></el-image>
              </a>
              <a v-else href="javascript:;" class="link noLink">
                <el-image :src="val.imgSrc" fit="contain"></el-image>
              </a>
            </div>
          </div>
          <!-- 商品展示 -->
          <ul v-if="v.moduleType === 'table'">
            <li v-for="(val, ind) in v.data" :key="ind">
              <img :src="val.commodityImg" alt @click="toProduct(val.commodityId)" />
              <p
                class="title"
                @click=" toProduct(val.commodityId)"
                :title="val.commodityName"
              >{{ val.commodityName }}</p>
            </li>
          </ul>
          <!-- 轮播展示 -->
          <el-carousel v-if="v.moduleType === 2" trigger="click" height="480px">
            <el-carousel-item v-for="(val,ind) in v.data" :key="ind">
              <a v-if="val.linkSrc" target="__blank" :href="val.linkSrc" class="link">
                <img :src="val.imgSrc" alt />
              </a>
              <a v-else href="javascript:;" class="link noLink">
                <img :src="val.imgSrc" alt />
              </a>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <!-- 促销展示 -->
      <div v-if="value.typeModule2 === 'promotionModul'" class="promotion-container">
        <div class="promotion-head">
          <span>限时促销</span>
          <span class="more" @click="toPromotionPage">
            更多
            <i class="el-icon-arrow-right"></i>
          </span>
        </div>
        <div class="promotion-content">
          <p class="img">
            <img src="../../../assets/xb-images/promotion.png" alt />
          </p>
          <el-carousel indicator-position="none" :autoplay="false" height="252px">
            <el-carousel-item v-for="(v, i) in value.data" :key="i">
              <ul class="promotion-list">
                <li
                  class="promotion-li"
                  v-for="(promotionGoods, promotionIndex) in v"
                  :key="promotionIndex"
                >
                  <div class="img" @click="toProduct(promotionGoods.commodityId)">
                    <img :src="promotionGoods.commodityImg" alt />
                  </div>
                  <p
                    class="promotion-goods-name"
                    @click="toProduct(promotionGoods.commodityId)"
                  >{{promotionGoods.commodityName}}</p>
                  <div class="promotion-goods-price">
                    <span class="promotion-discont-amount" v-if="promotionGoods.preferentialPrice">￥{{promotionGoods.preferentialPrice}}</span>
                    <span :class="promotionGoods.preferentialPrice?'promotion-original-price':'promotion-discont-amount'" v-if="promotionGoods.originalPrice">￥{{promotionGoods.originalPrice}}</span>
                  </div>
                </li>
              </ul>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <!-- 富文本区域展示 -->
      <div v-if="value.typeModule2 === 'editorModul'" class="editor-container" v-html="value.data"></div>
    </div>
  </div>
</template>

<script>
import { getToken, getXBGuestSetting } from "common/js/storage";
import XBHome from "models/xb/home.js";
const xbHome = new XBHome();
export default {
  props: {
    columnDetail: {
      type: Object,
      default: function () {
        return "";
      },
    },
  },
  data() {
    return {
      datas: [],
      displayPrice: true,
      touristRights: {},
      token: "",
    };
  },
  watch: {
    columnDetail: {
      handler(newvalue, oldvalue) {
        let arr = [];
        if (newvalue) {
          newvalue.topModuleInfoList.map((value, index, array) => {
            let details = JSON.parse(value.details);
            // console.log(details);
            if (index === 0) {
              if (details.type === 1) {
                if (details.data.moduleInfo.type === 2) {
                  this.$emit("openClassify", true);
                } else {
                  this.$emit("openClassify", false);
                }
              } else {
                this.$emit("openClassify", false);
              }
            }
            let obj = {};
            obj.typeModule1 = details.type;
            // 如果模块是大模块
            if (details.type === 1) {
              // obj.typeModule2 = details.data.moduleType;
              if (details.data.infoType === 1 || details.data.infoType === 2) {
                obj.typeModule2 = details.data.moduleInfo.type;
              } else if (details.data.infoType === 3) {
                obj.typeModule2 = "promotionModul";
              } else if (details.data.infoType === 4) {
                obj.typeModule2 = "editorModul";
              }
              obj.data = [];
              if (obj.typeModule2 === 2) {
                details.data.moduleInfo.data.map((v) => {
                  if (v.imgSrc) {
                    obj.data.push(v);
                  }
                });
              } else if (obj.typeModule2 === "promotionModul") {
                let num = Math.ceil(details.data.moduleInfo.data.length / 5);
                for (let i = 0; i < num; i++) {
                  let arr = [];
                  details.data.moduleInfo.data.map((v, index) => {
                    if (i * 5 <= index && index < (i + 1) * 5) {
                      let goodsId = v.commodityId;
                      xbHome
                        .getXBGoodsFew(goodsId)
                        .then((res) => {
                          let goodsObj = {};
                          goodsObj.ableInventory = v.ableInventory;
                          goodsObj.commodityClassify = v.commodityClassify;
                          goodsObj.commodityId = v.commodityId;
                          goodsObj.commodityImg = res.result.images[0];
                          goodsObj.commodityName = res.result.goodsName;
                          goodsObj.isSelected = v.isSelected;
                          goodsObj.retailPrice = res.result.marketPrice;
                          goodsObj.originalPrice = res.result.originalPrice;
                          goodsObj.preferentialPrice = res.result.preferentialPrice;
                          arr.push(goodsObj);
                        })
                        .catch(() => {
                          let goodsObj = {};
                          goodsObj.ableInventory = v.ableInventory;
                          goodsObj.commodityClassify = v.commodityClassify;
                          goodsObj.commodityId = v.commodityId;
                          goodsObj.commodityImg = v.commodityImg;
                          goodsObj.commodityName = v.commodityName;
                          goodsObj.isSelected = v.isSelected;
                          goodsObj.retailPrice = v.retailPrice;
                          goodsObj.originalPrice = v.originalPrice;
                          goodsObj.preferentialPrice = v.preferentialPrice;
                          arr.push(goodsObj);
                        });
                      // arr.push(v);
                    }
                  });
                  obj.data.push(arr);
                }
              } else {
                if (
                  details.data.moduleInfo.data[0] &&
                  details.data.moduleInfo.data[0].commodityId
                ) {
                  details.data.moduleInfo.data.map((value) => {
                    let goodsId = value.commodityId;
                    xbHome
                      .getXBGoodsFew(goodsId)
                      .then((res) => {
                        let goodsObj = {};
                        goodsObj.ableInventory = value.ableInventory;
                        goodsObj.commodityClassify = value.commodityClassify;
                        goodsObj.commodityId = value.commodityId;
                        goodsObj.commodityImg = res.result.images[0];
                        goodsObj.commodityName = res.result.goodsName;
                        goodsObj.isSelected = value.isSelected;
                        goodsObj.retailPrice = res.result.marketPrice;
                        obj.data.push(goodsObj);
                      })
                      .catch(() => {
                        let goodsObj = {};
                        goodsObj.ableInventory = value.ableInventory;
                        goodsObj.commodityClassify = value.commodityClassify;
                        goodsObj.commodityId = value.commodityId;
                        goodsObj.commodityImg = value.commodityImg;
                        goodsObj.commodityName = value.commodityName;
                        goodsObj.isSelected = value.isSelected;
                        goodsObj.retailPrice = value.retailPrice;
                        obj.data.push(goodsObj);
                      });
                  });
                } else {
                  obj.data = details.data.moduleInfo.data;
                }
              }
            } else {
              obj.typeModule2 = "";
              obj.data = [];
              details.data.map((v) => {
                if (v) {
                  let object = {};
                  object.moduleType = v.moduleInfo.type;
                  object.data = [];
                  if (v.moduleInfo.type === 1) {
                    v.moduleInfo.data.map((v) => {
                      if (v.imgSrc) {
                        object.data.push(v);
                      }
                    });
                  } else if (v.moduleInfo.type === 2) {
                    v.moduleInfo.data.map((v) => {
                      if (v.imgSrc) {
                        object.data.push(v);
                      }
                    });
                  } else {
                    if (
                      v.moduleInfo.data[0] &&
                      v.moduleInfo.data[0].commodityId
                    ) {
                      v.moduleInfo.data.map((value) => {
                        let goodsId = value.commodityId;
                        xbHome
                          .getXBGoodsFew(goodsId)
                          .then((res) => {
                            let goodsObj = {};
                            goodsObj.ableInventory = value.ableInventory;
                            goodsObj.commodityClassify =
                              value.commodityClassify;
                            goodsObj.commodityId = value.commodityId;
                            goodsObj.commodityImg = res.result.images[0];
                            goodsObj.commodityName = res.result.goodsName;
                            goodsObj.isSelected = value.isSelected;
                            goodsObj.retailPrice = res.result.marketPrice;
                            object.data.push(goodsObj);
                          })
                          .catch(() => {
                            let goodsObj = {};
                            goodsObj.ableInventory = value.ableInventory;
                            goodsObj.commodityClassify =
                              value.commodityClassify;
                            goodsObj.commodityId = value.commodityId;
                            goodsObj.commodityImg = value.commodityImg;
                            goodsObj.commodityName = value.commodityName;
                            goodsObj.isSelected = value.isSelected;
                            goodsObj.retailPrice = value.retailPrice;
                            object.data.push(goodsObj);
                          });
                      });
                    } else {
                      object.data = v.moduleInfo.data;
                    }
                    // object.data = v.moduleInfo.data;
                    // console.log(v.moduleInfo.data);
                  }
                  obj.data.push(object);
                }
              });
            }
            arr.push(obj);
          });
          this.datas = arr;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    setTimeout(() => {
      this.touristRights = getXBGuestSetting();
      this.token = getToken() ? getToken() : "";
      if (this.token) {
        this.displayPrice = true;
      } else {
        if (this.touristRights.guestShowPrice === 1) {
          this.displayPrice = true;
        } else {
          this.displayPrice = false;
        }
      }
    }, 500);
  },
  methods: {
    getClass(value1, value2) {
      // console.log(value1, value2);
      if (value1 === 1 && value2 === 1) {
        return "poster";
      } else if (value1 === 1 && value2 === 2) {
        return "carousel";
      } else if (value1 === 1 && value2 === 3) {
        return "banner";
      } else if (value1 === 1 && value2 === "table") {
        return "table";
      } else if (value1 === 1 && value2 === "promotionModul") {
        return "promotion";
      } else if (value1 === 1 && value2 === "editorModul") {
        return "editor";
      } else if (value1 === 2 && value2 === "") {
        return "smallModule";
      }
    },
    toProduct(id) {
      let routeUrl = this.$router.resolve({
        path: "/product",
        query: {
          id: id,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    toPromotionPage() {
      window.open("/goods/promotion-goods", "_blank");
    },
  },
};
</script>
<style lang='scss' scoped>
.homeView {
  min-height: 500px;
  .first-carousel {
    padding-left: 200px;
  }
  /* 轮播 */
  > .carousel {
    height: 400px;
    background: #fff;
    margin-bottom: 30px;
    .el-carousel {
      overflow: hidden;
      .el-carousel__item {
        .link {
          width: 1200px;
          height: 400px;
          img {
            width: 100%;
            height: 400px;
          }
        }
        .noLink {
          cursor: default;
        }
      }
    }
  }
  /* 海报 */
  > .poster {
    height: 400px;
    background: #fff;
    margin-bottom: 30px;
    .poster-container {
      height: 400px;
      overflow: hidden;
      img {
        width: 100%;
        height: 400px;
      }
      .noLink {
        cursor: default;
      }
    }
  }
  /* 5块 */
  > .table {
    height: 280px;
    margin-bottom: 20px;
    overflow: hidden;
    .table-container {
      height: 280px;
      width: 1220px;
      display: flex;
      > div {
        width: 232px;
        box-sizing: border-box;
        background: #fff;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        flex-direction: column;
        padding-top: 20px;
        margin-right: 10px;
        .img {
          width: 160px;
          height: 160px;
          margin-bottom: 20px;
          cursor: pointer;
        }
        p {
          width: 212px;
          font-size: 12px;
          font-weight: 500;
          color: rgba(96, 98, 102, 1);
          line-height: 20px;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
        .title {
          height: 40px;
          cursor: pointer;
        }
        .title:hover {
          color: rgba(223, 52, 69, 1);
        }
        .price {
          font-size: 14px;
          margin-top: 10px;
          color: #df3445;
        }
      }
    }
  }
  /* 广告图 */
  > .banner {
    height: 80px;
    background: #fff;
    margin-bottom: 30px;
    .banner-container {
      height: 80px;
      overflow: hidden;
      img {
        width: 100%;
        height: 80px;
      }
      .noLink {
        cursor: default;
      }
    }
  }
  /* 3大块 */
  > .smallModule {
    height: 450px;
    margin-bottom: 30px;
    overflow: hidden;
    .smallModule-container {
      height: 450px;
      width: 1230px;
      display: flex;
      > div {
        box-sizing: border-box;
        /* padding: 20px; */
        width: 390px;
        background: #fff;
        margin-right: 15px;
        .poster-one {
          width: 390px;
          height: 450px;
          .content {
            width: 390px;
            height: 450px;
            overflow: hidden;
            padding: 10px;
            box-sizing: border-box;
            .link {
              display: block;
              width: 370px;
              height: 430px;
              outline: none;
              .el-image {
                width: 100%;
                height: 100%;
              }
            }
            .noLink {
              cursor: default;
            }
          }
        }
        .poster-two {
          width: 390px;
          height: 450px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          box-sizing: border-box;
          padding: 10px;
          .content {
            width: 370px;
            height: 210px;
            .link {
              width: 100%;
              height: 100%;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .noLink {
              cursor: default;
            }
          }
        }
        ul {
          display: flex;
          flex-wrap: wrap;
          padding: 5px 20px;
          width: 390px;
          height: 450px;
          box-sizing: border-box;
          li {
            width: 175px;
            height: 220px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            flex-direction: column;
            padding-top: 5px;
            img {
              width: 150px;
              height: 150px;
              margin-bottom: 15px;
              cursor: pointer;
              border: 0px;
            }
            p {
              width: 155px;
              cursor: pointer;
              font-size: 12px;
              line-height: 20px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
            }
            p:hover {
              color: rgba(223, 52, 69, 1);
            }
          }
          li:nth-child(1) {
            border-right: 1px solid #f5f7fa;
            border-bottom: 1px solid #f5f7fa;
          }
          li:nth-child(2) {
            border-bottom: 1px solid #f5f7fa;
          }
          li:nth-child(3) {
            border-right: 1px solid #f5f7fa;
          }
        }
        .el-carousel {
          overflow: hidden;
          .el-carousel__item {
            .link {
              width: 390px;
              height: 450px;
              img {
                width: 390px;
                height: 450px;
              }
            }
            .noLink {
              cursor: default;
            }
          }
        }
      }
    }
  }
  /* 促销列表 */
  > .promotion {
    height: 294px;
    margin-bottom: 30px;
    .promotion-container {
      .promotion-head {
        height: 24px;
        padding: 10px 0px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 18px;
        color: #666666;
        .more {
          font-size: 14px;
          cursor: pointer;
        }
      }
      .promotion-content {
        background: #fff;
        display: flex;
        .img {
          width: 200px;
        }
      }
      .el-carousel {
        width: 1000px;
        .el-carousel__container {
          .promotion-list {
            width: 1200px;
            display: flex;
            .promotion-li {
              position: relative;
              width: 200px;
              height: 252px;
              display: flex;
              box-sizing: border-box;
              padding-top: 20px;
              flex-direction: column;
              align-items: center;
              .img {
                width: 160px;
                height: 160px;
                margin-bottom: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                img {
                  max-width: 100%;
                  max-height: 100%;
                }
              }
              .promotion-goods-name {
                width: 155px;
                font-size: 12px;
                font-weight: 500;
                color: rgba(96, 98, 102, 1);
                line-height: 20px;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                overflow: hidden;
              }
              .promotion-goods-name:hover {
                cursor: pointer;
                color: rgba(223, 52, 69, 1);
              }
              .promotion-goods-price {
                width: 100%;
                display: flex;
                justify-content: flex-start;
                font-size: 14px;
                font-weight: 400;
                color: #999999;
                padding-left: 41px;
                margin-top: 8px;
                .promotion-discont-amount {
                  color: #DF3445;
                }
                .promotion-original-price {
                  margin-left: 10px;
                  text-decoration: line-through;
                }
              }
            }
            .promotion-li:after {
              content: "";
              width: 1px;
              height: 160px;
              position: absolute;
              top: 20px;
              right: 0px;
              background: #eeeeee;
            }
            .promotion-li:last-child:after {
              content: "";
              width: 0px;
            }
          }
        }
      }
    }
  }
  /* 富文本内容 */
  > .editor {
    min-height: 100px;
    background: #fff;
    margin-bottom: 30px;
  }
}
</style>
<style lang="scss">
.homeView {
  > .carousel {
    .el-carousel {
      .el-carousel__container {
        .el-carousel__arrow {
          width: 24px;
          height: 80px;
          border-radius: 0;
          background-color: rgba(31, 45, 61, 0.4);
          font-size: 20px;
        }
      }
    }
  }
  .editor {
    line-height: 32px;
    font-size: 14px;
    table {
      border-top: 1px solid #ccc;
      border-left: 1px solid #ccc;
    }
    table td,
    table th {
      border-bottom: 1px solid #ccc;
      border-right: 1px solid #ccc;
      padding: 3px 5px;
    }
    table th {
      border-bottom: 2px solid #ccc;
      text-align: center;
    }

    /* blockquote 样式 */
    blockquote {
      display: block;
      border-left: 8px solid #d0e5f2;
      padding: 5px 10px;
      margin: 10px 0;
      line-height: 1.4;
      font-size: 100%;
      background-color: #f1f1f1;
    }

    /* code 样式 */
    code {
      display: inline-block;
      *display: inline;
      *zoom: 1;
      background-color: #f1f1f1;
      border-radius: 3px;
      padding: 3px 5px;
      margin: 0 3px;
    }
    pre code {
      display: block;
    }

    /* ul ol 样式 */
    ul,
    ol {
      margin: 10px 0 10px 20px;
      li {
        line-height: 32px;
      }
    }
    ol {
      li {
        list-style: decimal;
      }
    }
    ul {
      li {
        list-style: disc;
      }
    }
    p {
      line-height: 1.5;
      margin: 10px 0;
    }
  }
}
</style>
